<template>
  <Header></Header>
  <LayoutPrincipal>
    <div style="display: flex;">
      <div class="profile-info">
        <section class="perfil">
          <h1>Perfil</h1>
          <img src="../assets/svg/icono-usuario.svg" alt="Foto de perfil" />
        </section>
      </div>
      <div class="edit-form">
        <section class="informacion">
          <h2>Informacion actual del perfil</h2>
          <div>
            <div class="contenedorInputs">
              <label>Nombre:</label>
              <input type="text" maxlength="20" id="nombre" :value="usuario.nombre" readonly />
            </div>
            <div class="contenedorInputs">
              <label>Apellido paterno:</label>
              <input type="text" maxlength="20" id="apellid_paterno" :value="usuario.apellido_paterno" readonly />
            </div>
            <div class="contenedorInputs">
              <label>Apellido materno:</label>
              <input type="text" maxlength="20" id="apellido_materno" :value="usuario.apellido_materno" readonly />
            </div>
            <div class="contenedorInputs">
              <label>Rol:</label>
              <input type="tel" maxlength="10" id="rol" :value="FormatoRol(usuario.rol)" readonly />
            </div>
            <div class="contenedorInputs">
              <label>Correo:</label>
              <input type="text" maxlength="40" id="correo" :value="usuario.correo" readonly />
            </div>
            <div class="contendorBotones">
              <router-link to="/Dashboard">
                <Button class="btn-regresar" id="return-to-top">Regresar</Button>
              </router-link>
              <Button class="btn-cambiar-contrasena" @click="mostrarModalContrasena = true">
                Cambiar contraseña
              </Button>
            </div>
          </div>
        </section>
      </div>

      <div class="edit-form">
        <section class="informacion2">
          <h2 class="notititulo">Notificaciones</h2>
          <section class="sombraInputNoti" v-for="(notificacion, index) in notificacion" :key="index">
            <div class="contenedorNotificaciones">
              <div class="contenedorImgNoti">
                <img class="imgNoti" src="../assets/images/notificacion.png" alt="" />
              </div>
              <div class="infoNotificacion">
                <div class="tituloNoti">Notificación</div>
                <div>{{ notificacion.mensaje }}</div>
              </div>
              <div class="tachitaNoti" @click="eliminarNotificacion(index)">
                <div>X</div>
              </div>
            </div>
          </section>
          <section>
          </section>
        </section>
      </div>

      <section class="informacionAyuda">
        <h2 class="notititulo">¿Necesitas ayuda?</h2>

        <div class="ayuda-contacto">
          <p class="texto-ayuda">Si tienes dudas o necesitas soporte, puedes contactarnos por los siguientes medios:</p>
          <ul class="lista-contacto">
            <li>
              <i class="fa-solid fa-phone"></i>
              <strong>Diana: </strong>
              <a href="tel:+6672476316">6672476316</a>
            </li>
            <li>
              <i class="fa-solid fa-envelope"></i>
              <strong>Correo:</strong>
              <a href="mailto:contacto@nola.mx">contacto@nola.mx</a>
            </li>
          </ul>
        </div>

        <div class="mini-chat">
          <div class="chat-header">
            <span>Chat de Soporte</span>
          </div>
          <div class="chat-mensajes" ref="contenedorMensajes">
            <div v-for="(msg, index) in mensajes" :key="index" :class="['mensaje', msg.remitente]">
              {{ msg.texto }}
            </div>
          </div>
          <div class="chat-input">
            <input type="text" v-model="nuevoMensaje" @keyup.enter="enviarMensaje" :disabled="estadoChat === 'cerrado'"
              placeholder="Escribe tu mensaje..." />
            <Button class="btn-enviar" @click="enviarMensaje" :disabled="estadoChat === 'cerrado'">Enviar</Button>
            <Button class="btn-finalizar" @click="finalizarChat" :disabled="estadoChat === 'cerrado'">Finalizar</Button>
            <Button class="btn-reabrir" v-if="estadoChat === 'cerrado'" @click="reabrirChat">
              Reabrir Chat
            </Button>
          </div>
        </div>
      </section>
    </div>

    <CambiarContrasena
      v-if="mostrarModalContrasena"
      @cerrarModal="mostrarModalContrasena = false"
    />
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from '@/layouts/layoutPrincipal.vue';
import Header from '../layouts/Header.vue';
import Button from '@/components/Forms/Button.vue';
import CambiarContrasena from '@/components/Login/CambiarContrasena.vue';

export default {
  components: {
    Header,
    LayoutPrincipal,
    Button,
    CambiarContrasena,
  },
  data() {
    return {
      mostrarModalContrasena: false,
      notificacion: [],
      usuario: {
        id: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        correo: '',
        rol: ''
      },
      mensajes: [
        { texto: 'Hola, ¿en qué podemos ayudarte?', remitente: 'soporte' }
      ],
      nuevoMensaje: '',
      rolOpciones: {
        ROLE_ADMIN: 'Administrador',
        ROLE_KIOSKO: 'Kiosko',
        ROLE_USER: 'Usuario',
        ROLE_JEFE: 'Jefe',
        ROLE_DESARROLLADOR: 'Desarrollador',
        ROLE_TESTER: 'Tester',
        ROLE_RESIDENTE: 'Residente'
      }
    };
  },
  methods: {
    FormatoRol(rol) {
      return this.rolOpciones[rol] || rol;
    },
    /*     eliminarNotificacion(index) {
          this.notificacion.splice(index, 1);
        }, */
    agregarNotificacion() {
      this.notificacion.push({});
    },
    enviarMensaje() {
      if (!this.nuevoMensaje.trim()) return;

      const mensaje = {
        texto: this.nuevoMensaje.trim(),
        remitente: 'usuario',
        hora: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      };

      const data = localStorage.getItem("chats_soporte");
      let chats = data ? JSON.parse(data) : {};

      const idUsuario = this.usuario.id;

      if (!chats[idUsuario]) {
        chats[idUsuario] = {
          ticket_id: `TK${Date.now()}`,
          usuario_id: idUsuario,
          nombre: this.usuario.nombre,
          asunto: 'Soporte desde perfil',
          estado: 'abierto',
          mensajes: []
        };
      }

      if (chats[idUsuario].estado === 'cerrado') {
        alert('Este chat está cerrado. No puedes enviar mensajes.');
        this.nuevoMensaje = '';
        return;
      }

      chats[idUsuario].mensajes.push(mensaje);
      localStorage.setItem("chats_soporte", JSON.stringify(chats));
      window.dispatchEvent(new Event("storage")); // notifica a otros tabs/componentes
      this.nuevoMensaje = '';
      this.scrollChatToBottom();
    },
    scrollChatToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.contenedorMensajes;
        if (container) container.scrollTop = container.scrollHeight;
      });
    },
    cargarNotificaciones() {
      const data = localStorage.getItem("notificaciones");
      this.notificacion = data ? JSON.parse(data) : [];
    },
    eliminarNotificacion(index) {
      this.notificacion.splice(index, 1);
      localStorage.setItem("notificaciones", JSON.stringify(this.notificacion));
      window.dispatchEvent(new Event('storage'));  // Notifica a otros componentes
    },
    cargarChat() {
      const data = localStorage.getItem("chats_soporte");
      const chats = data ? JSON.parse(data) : {};
      const chatUsuario = chats[this.usuario.id];

      if (chatUsuario) {
        this.mensajes = chatUsuario.mensajes || [];
        this.estadoChat = chatUsuario.estado || 'abierto';
      } else {
        this.mensajes = [];
        this.estadoChat = 'abierto';
      }
    },
    finalizarChat() {
      if (!confirm('¿Seguro que deseas finalizar el chat?')) return;

      const data = localStorage.getItem("chats_soporte");
      let chats = data ? JSON.parse(data) : {};
      const idUsuario = this.usuario.id;

      if (chats[idUsuario]) {
        chats[idUsuario].estado = 'cerrado';
        chats[idUsuario].mensajes.push({
          texto: 'El chat ha sido cerrado por el usuario.',
          remitente: 'usuario',
          hora: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        });

        localStorage.setItem("chats_soporte", JSON.stringify(chats));
        window.dispatchEvent(new Event("storage"));
        this.cargarChat();
      }
    },
    reabrirChat() {
      if (!confirm('¿Seguro que deseas reabrir el chat?')) return;

      const data = localStorage.getItem("chats_soporte");
      let chats = data ? JSON.parse(data) : {};
      const idUsuario = this.usuario.id;

      if (chats[idUsuario]) {
        chats[idUsuario].estado = 'abierto';
        chats[idUsuario].mensajes.push({
          texto: 'El chat ha sido reabierto por el usuario.',
          remitente: 'usuario',
          hora: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        });

        localStorage.setItem("chats_soporte", JSON.stringify(chats));
        window.dispatchEvent(new Event("storage")); // Notifica a otros componentes
        this.cargarChat();
      }
    },
  },
  mounted() {
    const savedUser = localStorage.getItem('usuario');
    if (savedUser) {
      this.usuario = JSON.parse(savedUser);
    }

    this.cargarNotificaciones();
    this.cargarChat();

    window.addEventListener("storage", () => {
      this.cargarNotificaciones();
      this.cargarChat();
    });
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.cargarNotificaciones);
  }
};
</script>



<style scoped>
.module-container {
  display: flex;
}

.container-white {
  background-color: #fafafa;
  height: calc(97vh - 100px);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.perfil {
  box-shadow: 0px 3px 6px #00000029;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 10px;
}

.profile-info {
  /*   flex-basis: 10%; */
  justify-content: center;
  display: flex;
  align-items: center;
  margin-right: 30px;
}

.profile-info h1 {
  margin-top: 0;
}

.profile-info img {
  width: 100%;
}

.edit-form {
  flex-basis: 40%;
}

.contenedorInputs {
  display: flex;
  flex-direction: column;
}

.contendorBotones {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 18px;
  text-align: center;
  position: sticky;
}

.btn-cambiar-contrasena {
  background-color: #6E44DA;
  color: #fff;
}

.informacion {
  box-shadow: 0px 3px 6px #00000029;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  height: calc(93vh - 100px);
}

.informacion2 {
  box-shadow: 0px 3px 6px #00000029;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  height: calc(93vh - 100px);
  margin-left: 30px;
  overflow-y: auto;
  overflow-y: scroll;
}

.informacionAyuda {
  box-shadow: 0px 3px 6px #00000029;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  height: calc(93vh - 100px);
  margin-left: 30px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}

.notititulo {
  margin: 0px 0px 30px 0px;
  font-size: 25px;
  color: #6E44DA;
  font-weight: bolder;
  font-style: italic;
}

.sombraInputNoti {
  box-shadow: 0px 3px 6px #00000029;
  background-color: #ffffff;
  border-radius: 10px;
  gap: 15px;
}

.contenedor-boton-fijo {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  /* Fondo para que las notificaciones no se vean detrás */
  padding: 15px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Sombra opcional */
  justify-content: center;
  align-items: center;
}

.contenedorNotificaciones {
  position: sticky;
  top: 0;
  background: #f1f1f1;
  padding: 10px;
  display: flex;
  gap: 10px;
  z-index: 100;
  margin-bottom: 15px;
}

.contenedorImgNoti {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.imgNoti {
  height: 40px;
}

.infoNotificacion {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 20px;
}

.tituloNoti {
  font-weight: bold;
  font-size: 17px;
}

.tachitaNoti {
  padding: 7px 10px 0px 0px;
  cursor: pointer;
}

.informacion h2 {
  font-size: 25px;
  color: #6E44DA;
  font-weight: bolder;
  font-style: italic;
  margin-top: 0;
}

.informacion label {
  margin-bottom: 7px;
  font-weight: bold;
}

.informacion input {
  height: 39px;
  border: 0px solid #000000;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #000000;
  padding: 0px 7px;
  border-radius: 10px;
  margin-bottom: 27px;
  background: #f1f1f1;
}

.ayuda-contacto {
  background: #f1f1f1;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 15px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 20px;
}

.ayuda-contacto h3 {
  margin-top: 0;
  font-size: 20px;
  color: #691c32;
  margin-bottom: 10px;
  font-weight: bold;
}

.titulo-ayuda {
  margin-top: 0;
  font-size: 22px;
  color: #691c32;
  font-weight: bold;
  margin-bottom: 10px;
}

.texto-ayuda {
  margin-bottom: 18px;
}

.lista-contacto {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.lista-contacto li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 13px;
}

.lista-contacto i {
  color: #6E44DA;
  font-size: 18px;
  min-width: 20px;
  text-align: center;
}

.lista-contacto a {
  color: #007bff;
  text-decoration: none;
}

.lista-contacto a:hover {
  text-decoration: underline;
}

/* Mini Chat Styles */
.mini-chat {
  background-color: #fff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 400px;
  max-height: 400px;
  overflow: hidden;
  /*   flex-shrink: 0; */
}

.chat-header {
  background-color: #000000;
  color: white;
  padding: 10px 15px;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}

.chat-mensajes {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mensaje {
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 70%;
  word-wrap: break-word;
}

.mensaje.soporte {
  background: #ccc;
  color: #000;
  align-self: flex-start;
}

.mensaje.usuario {
  background-color: #691c32;
  color: white;
  align-self: flex-end;
}

.chat-input {
  display: flex;
  /*   border-top: 1px solid #ccc; */
  padding: 10px;
  gap: 8px;
}

.chat-input input {
  flex-grow: 1;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
}
</style>
